export default {
  handleDocumentContainer: {
    title: 'Adjunte un presupuesto',
    text: 'Preséntanos un presupuesto de un artesano de tu elección. Esto será revisado por nuestro equipo técnico que lo validará o se pondrá en contacto con usted si es necesario.',
    actions: {
      primary: 'Continuar'
    },
    documentUploadStep: {
      actions: {
        primary: 'Adjuntar documento'
      }
    },
    icrModal: {
      title: 'Carga de archivos',
      text1: 'Los archivos se están procesando actualmente. Por favor, siga esperando.',
      text2: 'El proceso puede durar unos minutos.',
      text3: 'Estamos procesando sus documentos. En unos minutos validaremos su indemnización.'
    }
  }
}
